<template>
    <div>
        <v-app-bar
            app
            elevate-on-scroll
            color="white"
            >
            <v-img
                alt="Logo"
                src="@/assets/images/logo.png"
                max-height="90%"
                max-width="160"
                contain
                class="shrink mx-2"
                ></v-img>

            <v-spacer></v-spacer>

            <v-toolbar-items class="d-none d-md-flex">
                <v-btn
                    v-for="(menu, i) in menus"
                    :key="i"
                    @click="scrollTo(menu.to)"
                    text
                    >
                    {{ menu.text }}
                </v-btn>
                <v-btn @click="toLogin" text class="primary--text">Masuk</v-btn>
                <v-btn @click="toSignup" outlined class="primary white--text">Daftar</v-btn>
            </v-toolbar-items>

            <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="d-md-none"></v-app-bar-nav-icon>
        </v-app-bar>

        <v-navigation-drawer
            v-model="drawer"
            app
            right
            v-if="$vuetify.breakpoint.smAndDown"
            >
            <v-list nav>
                <v-list-item
                    v-for="(menu, i) in menus"
                    :key="i"
                    link
                    >
                    <v-list-item-content>
                        <v-list-item-title @click="scrollTo(menu.to)">{{ menu.text }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item link>
                    <v-list-item-content>
                        <v-list-item-title>Masuk</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item link>
                    <v-list-item-content>
                        <v-list-item-title>Daftar</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
import scrollTo from '@/tools/scrollTo'

export default {
    data() {
        return {
            drawer: false,
            menus: [
                { text: 'Tentang Kami', to: '#about' },
                { text: 'Harga', to: '#price' },
                // { text: 'Testimoni', to: '#testimony' },
                { text: 'FAQ', to: '#faq' },
                { text: 'Kontak', to: '#contact' },
            ]
        }
    },

    methods: {
        scrollTo,

        toLogin() {
            this.scrollTo('#jumbotron')
            this.$store.set('home/authTab', 0)
        },

        toSignup() {
            this.scrollTo('#jumbotron')
            this.$store.set('home/authTab', 1)
        }
    }
}
</script>
